import publicPath from '../../utils/publicPath';

const homepage = {
  hero: {
    text: {
      main: 'Find football',
      main1: 'near me',
      secondary:
        'Know what you’re after? Tell us where you are and we’ll show you everything.',
      secondary1: 'Or, tell us a bit more about what you’re looking for!',
      secondary2: 'Answer 6 quick questions to tailor your results',
    },
    ctaText: 'SHOW ME EVERYTHING!',
    ctaText1: 'Tailor my results!',

    images: {
      desktop: {
        src: publicPath('/images/desktop/home/homepageback.webp'),
      },
      mobile: {
        src: '/images/desktop/home/homeback_mobile.webp',
      },
    },
  },

  footballTypeHeadings: [
    {
      id: 1,
      heading: 'club football',
      description: 'Find a team to play in competitive leagues & competitons',
      href: 'https://www.englandfootball.com/play/club-football',
      images: {
        desktop: {
          // src: publicPath('/images/desktop/home/club-football.jpg'),
        },
        mobile: {
          // src: publicPath('/images/mobile/home/club-football.jpg'),
        },
      },
    },
    {
      id: 2,
      heading: 'casual football',
      description:
        'From 11-a-side to adapted forms of the game, find a kickabout that works for you. ',
      href: 'https://www.englandfootball.com/play/casual-football',
      images: {
        desktop: {
          // src: publicPath('/images/desktop/home/casual-football.jpg'),
        },
        mobile: {
          src: publicPath('/images/mobile/home/casual-football.jpg'),
        },
      },
    },
  ],

  WaysToPlay: [
    {
      id: 1,
      heading: 'FOOTBALL',
      name: 'FOOTBALL',
      videos: 'https://www.youtube.com/embed/b4BoZKY2UFw?autoplay=1',
      href: 'https://www.englandfootball.com/play/Ways-to-Play/11-a-side-football',
      description: (
        <>
          The most common football type, from Adult 11v11 teams, down to Youth
          Mini Soccer 5v5 teams. Games are tailored to age, experience,
          disabilities and more.
        </>
      ),
      footer: 'Find football near me',
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/football.webp'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/football.webp'),
        },
      },
    },
    {
      id: 2,
      heading: 'FUTSAL',
      name: 'FUTSAL',
      description: (
        <>
          A dynamic indoor football variant with tight spaces, rapid play, and a
          focus on individual skills, agility, and creativity, making it ideal
          for honing technical abilities.
        </>
      ),
      footer: 'Find futsal near me',
      videos: 'https://www.youtube.com/embed/Xk3bS3F6hGE?autoplay=1',
      href: 'https://www.englandfootball.com/play/Ways-to-Play/futsal',
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/futsal.webp'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/futsal.webp'),
        },
      },
    },
    {
      id: 3,
      heading: 'WALKING FOOTBALL',
      name: 'WALKING FOOTBALL',
      description: (
        <>
          With no running, jogging, heading, or physical contact -{' '}
          <b>Walking Football</b> prioritises safety and fun to allow players to
          continue playing the game they love but it's also a great introduction
          to football for those who haven't played much before.
        </>
      ),
      footer: 'Find walking football near me',
      videos: 'https://www.youtube.com/embed/7K39a5rucTE?autoplay=1',
      href: 'https://www.englandfootball.com/play/ways-to-play/walking-football',
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/walkingFootball.webp'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/walkingFootball.webp'),
        },
      },
    },
  ],

  teamVsFootball: [
    {
      id: 1,
      heading: 'TEAM FOOTBALL',
      videos: 'https://www.youtube.com/embed/b4BoZKY2UFw?autoplay=1',
      href: 'https://www.englandfootball.com/play/club-football',
      description: (
        <>
          <b>
            Football training, games and competitions with a set start and end
            date. Individuals play, as a team, in fixtures against other teams.
          </b>{' '}
          There is a spectrum of 'team based' ranging from structured, formal
          football through to a more relaxed environment like at a small sided
          league.
        </>
      ),
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/club-football.webp'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/club-football.webp'),
        },
      },
      buttonText: 'FIND TEAM FOOTBALL NEAR ME',
    },

    {
      id: 2,
      heading: 'SESSIONAL FOOTBALL',
      description: (
        <>
          Football that is not part of a competition, its non-comital, play
          based on your lifestyle, everyone is welcome regardless of your age,
          gender or ability. From Wildcats to Just Play, there is something for
          everyone.
        </>
      ),
      href: 'https://www.englandfootball.com/play/casual-football',
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/casual-football.webp'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/casual-football.webp'),
        },
      },
      buttonText: 'FIND SESSIONAL FOOTBALL NEAR ME',
    },
  ],

  FAProgrammes: [
    {
      id: 1,
      heading: 'WILDCATS',
      name: 'WILDCATS',
      videos: 'https://www.youtube.com/embed/co8zt5u4dJ4?autoplay=1',
      href: 'https://www.englandfootball.com/play/youth-football/wildcats',
      description: (
        <>
          Are you looking for a fun way for girls 5-11 to get involved with
          football? Then look no further! Wildcats is all about having loads of
          fun and meeting new amazing friends.
        </>
      ),
      footer: 'Find Wildcats near me',
      images: {
        desktop: {
          src: '/images/desktop/home/wildcats-logo-new.webp',
        },
        mobile: {
          src: '/images/desktop/home/wildcats-logo-new.webp',
        },
      },
    },

    {
      id: 2,
      heading: 'JUST PLAY',
      name: 'JUST PLAY',
      descriptionLine: (
        <>
          <b>Just Play</b> is for men, women and for those aged 16+ of all
          abilities. You may have never kicked a ball before or it might have
          been a while ago, whatever your reason, there's a space for you with
          Just Play. Just book online and turn up and play. We provide the
          pitch, balls, bibs and a Just Play Organiser looks after your session.
        </>
      ),
      videos: 'https://www.youtube.com/embed/7Fi8VQ9w7rg?autoplay=1',
      href: 'https://www.englandfootball.com/play/adult-football/just-play',
      footer: 'Find Just Play near me',
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/just-play-logo-new.webp'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/just-play-logo-new.webp'),
        },
      },
    },
    {
      id: 3,
      heading: (<>SQUAD GIRLS' FOOTBALL</>),
      name: "SQUAD GIRLS' FOOTBALL",
      description: (
        <>
          Aged 11-16 and keen to kickstart or continue your football journey? A
          fun, non-competitive way to play, develop skills and build confidence,
          whilst encouraging girls to play their way.
        </>
      ),
      videos: 'https://www.youtube.com/embed/Az0u_cer3R4?autoplay=1',
      href: 'https://www.englandfootball.com/play/youth-football/Squad-Girls-Football',
      footer: (<><p>Find Squad girls' football</p>
        <p>near me</p></>),
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/Squad-Girls-logo-new.webp'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/Squad-Girls-logo-new.webp'),
        },
      },
    },

    {
      id: 4,
      heading: 'COMETS',
      name: 'COMETS',
      descriptionFirstLine: (
        <>
          <p>
            <b>Comets</b> is a recreational, pan-disability football programme for
            disabled boys and girls aged between 5-11 to play together.
          </p>
        </>
      ),
      descriptionSecondLine: (
        <>
          Comets offers a new, flexible and inclusive way of playing, one that's
          all about playfulness, friendships and having fun. More than anything,
          Comets is football that breaks the old rules and replaces them with a
          brand new one: JUST BE YOU.
        </>
      ),
      videos: 'https://www.youtube.com/embed/L8-OUvAm8Zw?autoplay=1',
      href: 'https://www.englandfootball.com/play/Disability-Football/Comets',
      footer: 'Find Comets near me',
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/comets-logo-new.webp'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/comets-logo-new.webp'),
        },
      },
    },
  ],

  faDISABILITY: [
    {
      id: 1,
      description: 'Fun and friendly football for girls aged 5-11. ',
      href: 'https://www.englandfootball.com/play/womens-and-girls-football/weetabix-wildcats',
      initiativeLogo: {
        desktop: {
          src: publicPath('/images/desktop/home/wildcats-logo.svg'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/wildcats-logo.svg'),
        },
      },
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/wildcats.png'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/wildcats.png'),
        },
      },
    },
    {
      id: 2,
      description:
        'Casual football for everyone. Fancy a game? Just say, Just Play. ',
      href: 'https://www.englandfootball.com/play/adult-football/just-play',
      initiativeLogo: {
        desktop: {
          src: publicPath('/images/desktop/home/just-play-logo.svg'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/just-play-logo.svg'),
        },
      },
      images: {
        desktop: {
          src: publicPath('/images/desktop/home/just-play.jpg'),
        },
        mobile: {
          src: publicPath('/images/desktop/home/just-play.jpg'),
        },
      },
    },
    // once received link for age-uk will uncomment below code
    // {
    //   id: 3,
    //   description:
    //     'Stay active with small-sided Walking Football for over 50s.',
    //   href: 'https://www.englandfootball.com/play/age-uk',
    //   initiativeLogo: {
    //     desktop: {
    //       src: publicPath('/images/desktop/home/age-uk-logo.svg'),
    //     },
    //     mobile: {
    //       src: publicPath('/images/desktop/home/age-uk-logo.svg'),
    //     },
    //   },
    //   images: {
    //     desktop: {
    //       src: publicPath('/images/desktop/home/age-uk.png'),
    //     },
    //     mobile: {
    //       src: publicPath('/images/desktop/home/age-uk.png'),
    //     },
    //   },
    // },
  ],

  DisabilityFootballData: [
    {
      id: 1,
      heading: 'DISABILITY FOOTBALL',
      name: 'PAN DISABILITY FOOTBALL',
      videos: 'https://www.youtube.com/embed/iRjqLD5QrDA?autoplay=1',
      description: (
        <>
          <b>Pan Disability Football</b> has the most competition-based
          opportunities in England play this format, making it the largest
          disability-specific football pathway.
        </>
      ),
      footer: (<><p>Find pan disability</p><p>football near me</p></>),
      images: {
        desktop: {
          src: 'images/desktop/home/disabilityFootball/panDisabilityFootball.webp',
        },
        mobile: {
          src: 'images/desktop/home/disabilityFootball/panDisabilityFootball.webp',
        },
      },
    },
    {
      id: 2,
      heading: 'DISABILITY FOOTBALL',
      name: 'AMPUTEE FOOTBALL',
      descriptionFirstLine: (
        <>
          <p>
            <b>Amputee Football</b> is a 7v7 format of football for anyone with
            an amputation or limb difference.
          </p>
        </>
      ),
      descriptionSecondLine: (
        <>
          <p style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            Amputee players can (and do) play mainstream, pan-disability, and
            amputee-specific football. In pan-disability and amputee-specific
            football, players can play with their prosthesis or without their
            prosthesis (on crutches).
          </p>
        </>
      ),
      descriptionThirdLine: (
        <>
          Mainstream football also allows the use of a prosthesis and we have
          produced guidelines on{' '}
        </>
      ),
      descriptionLink: (
        <>
          <a
            href="https://www.thefa.com/-/media/thefacom-new/files/get-involved/2021/guidelines-to-playing-football-with-a-prosthesis.ashx#:~:text=It%20is%20recommended%20that%20players,to%20the%20player%20wearing%20the"
            style={{ color: '#011E41' }}
          >
            Playing Football with a Prosthesis
          </a>
          .{' '}
        </>
      ),

      videos: 'https://www.youtube.com/embed/rcBdUuIiYQs?autoplay=1',
      footer: (
        <>
          <p>Find Amputee </p>
          <p>football near me</p>
        </>
      ),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/amputteFootball.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/amputteFootball.webp'
          ),
        },
      },
    },
    {
      id: 3,
      heading: 'DISABILITY FOOTBALL',
      name: 'BLIND FOOTBALL',
      description: (
        <>
          <b>Blind Football</b> is an adapted version of futsal and the only
          format currently included in the Paralympic Games. Blind Players can
          safely participate in blind-specific football only.
        </>
      ),
      videos: 'https://www.youtube.com/embed/18Wfa7BkgjM?autoplay=1',
      footer: (<><p>Find Blind</p><p>football near me</p></>),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/blindFootball.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/blindFootball.webp'
          ),
        },
      },
    },
    {
      id: 4,
      heading: 'DISABILITY FOOTBALL',
      name: 'CEREBRAL PALSY FOOTBALL',
      description: (
        <>
          <b>Cerebral Palsy Football</b> is played by individuals who have
          cerebral palsy or another neurological disorder that resulted in
          physical impairment. It is often referred to as 'CP football'.
        </>
      ),
      videos: 'https://www.youtube.com/embed/nqueX5KVb6M?autoplay=1',
      footer: (<><p>Find Cerebral Palsy</p><p>football near me</p></>),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/cerebralPalsy.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/cerebralPalsy.webp'
          ),
        },
      },
    },
    {
      id: 5,
      heading: 'DISABILITY FOOTBALL',
      name: 'DEAF FOOTBALL',
      description: (
        <>
          <b>Deaf Football</b> , a very similar format to mainstream football,
          deaf football has both 11-aside and futsal versions. The 11-a-side
          format is in the Deaflympics which take place every four years.
        </>
      ),
      videos: 'https://www.youtube.com/embed/M7HUd1ZE5fM?autoplay=1',
      footer: (<><p>Find Deaf</p><p>football near me</p></>),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/deafFootball.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/deafFootball.webp'
          ),
        },
      },
    },
    {
      id: 6,
      heading: 'DISABILITY FOOTBALL',
      name: 'DOWNS SYNDROME',
      description: (
        <>
          <b>Downs Football</b> tends to be 5-a-side in format, with friendly
          festivals held across England. Players with Down's syndrome often
          participate in pan-disability football as well.
        </>
      ),
      footer: (<><p>Find Downs</p><p>football near me</p></>),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/downsSyndrome.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/downsSyndrome.webp'
          ),
        },
      },
    },
    {
      id: 7,
      heading: 'DISABILITY FOOTBALL',
      name: 'FRAME FOOTBALL',
      description: (
        <>
          <b>Frame Football</b> is an adapted format of football designed for
          players who use a frame or walker. This format is ideally suited to
          being played indoor on flat smooth surfaces.
        </>
      ),
      videos: 'https://www.youtube.com/embed/jHknY6YVpCw?autoplay=1',
      footer: (<><p>Find Frame</p><p>football near me</p></>),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/frameFootball.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/frameFootball.webp'
          ),
        },
      },
    },
    {
      id: 8,
      heading: 'DISABILITY FOOTBALL',
      name: 'LEARNING DISABILITY',
      description: (
        <>
          <b>Learning Disability Football</b> is a format of football
          exclusively for people with a learning disability. It is usually the
          most represented within pan-disability football.
        </>
      ),
      footer: (<><p>Find Learning Disability</p><p>football near me</p></>),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/learningDisability.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/learningDisability.webp'
          ),
        },
      },
    },
    {
      id: 9,
      heading: 'DISABILITY FOOTBALL',
      name: 'MENTAL HEALTH',
      description: (
        <>
          <b>Mental Health Football</b> has several teams in England. They play
          in pan-disability or mental health specific leagues. 5-a-side to
          11-a-side festivals also take place across the country.
        </>
      ),
      footer: (<><p>Find Mental Health</p><p>football near me</p></>),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/mentalHealth.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/mentalHealth.webp'
          ),
        },
      },
    },
    {
      id: 10,
      heading: 'DISABILITY FOOTBALL',
      name: 'PARTIALLY SIGHTED  FOOTBALL',
      description: (
        <>
          <b>Partially Sighted Football</b> is an adapted version of futsal,
          sometimes known as B2/B3 football. In partially sighted football,
          players have some level of sight.
        </>
      ),
      videos: 'https://www.youtube.com/embed/PBB0RqaksHI?autoplay=1',
      footer: (<><p>Find partially Sighted</p><p>football near me</p></>),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/partiallySighted.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/partiallySighted.webp'
          ),
        },
      },
    },
    {
      id: 11,
      heading: 'DISABILITY FOOTBALL',
      name: 'POWER CHAIR FOOTBALL',
      description: (
        <>
          <b>Powerchair Football</b> is an indoor format for anyone who uses
          powered wheelchair or has limited movement in a manual wheelchair.
          Players of all ages and genders can play together.
        </>
      ),
      videos: 'https://www.youtube.com/embed/Ql_qK3wC2AY?autoplay=1',
      footer: (<><p>Find powerchair</p><p>football near me</p></>),
      images: {
        desktop: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/powerChair.webp'
          ),
        },
        mobile: {
          src: publicPath(
            '/images/desktop/home/disabilityFootball/powerChair.webp'
          ),
        },
      },
    },
  ],
};

export default homepage;
